import styled from 'styled-components';

import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';

export const LazyCallBack = styled.div`
    width: 100%;
    flex-direction: column;
    background: #FFFFFF;
`;

export const ContentWrapper = styled.div`
    padding: 24px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        padding: 32px 32px 24px 32px;
    }
`;

export const SH3 = styled(H3)`
    padding-right: 35px;
`;

export const Form = styled.div`
    width: 100%;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;
    row-gap: 16px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        align-items: flex-start;
    }
`;

export const InputFields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    width: 100%;

    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
    }
`;

const Input = styled(InputSimple)`
    flex: 1;
    margin-bottom: 0;
`;

export const NameInput = nameDecorator(Input);

export const PhoneInput = phoneDecorator(Input);
